import React from 'react';
import iconTL from '../../../../../../assets/icons/charts/overview/icon_topic_line_chart.svg';
import SVG from "react-inlinesvg";

const IconTopicLine = () => (
    <SVG src={iconTL} height={40} style = {{ marginTop: 10}} />
);
export default IconTopicLine;